export default "/images/8b8d55417d36a5b31da8b472a9c05fb8.avif";